import { Divider, Empty, Text } from "../../components";
import { Order } from "../../types/item";
import { OrderType } from "../../types/enums";
import { taxFromTotals } from "../../utils/totals";
import Summary from "../summary";
import { useApp } from "../../hooks";
import { useMemo } from "react";

const OrderSummary = (order: Order) => {
  const { payments } = useApp();
  const payment = useMemo(
    () =>
      payments.find((item) => item.method === order.paymentMethod)?.displayName,
    [payments, order.paymentMethod],
  );
  const pickup = order.orderType === OrderType.pickup;
  const details = [
    !pickup &&
      order.deliveryInfo?.deliveryAddress && {
        label: "Address",
        value: [order.deliveryInfo.deliveryAddress, order.areaName]
          .filter(Boolean)
          .join(", "),
      },
    !pickup &&
      order.deliveryInfo?.nearestLandmark && {
        label: "Landmark",
        value: order.deliveryInfo.nearestLandmark,
      },
    pickup &&
      order.branch?.name && { label: "Branch", value: order.branch.name },
    pickup &&
      order.pickupSlotMinutes && {
        label: "Pickup time",
        value: `${order.pickupSlotMinutes} min`,
      },
    payment && { label: "Payment", value: payment },
    order.deliveryInfo?.notes && {
      label: "Note",
      value: order.deliveryInfo.notes,
    },
    order.changeRequest && { label: "Change", value: order.changeRequest },
    order.isGift &&
      order.giftMessage && {
        label: "Gift message",
        value: order.giftMessage,
      },
  ].filter((row): row is { label: string; value: string } => !!row);

  if (!order.cartSnapshot) return <Empty description="No Order Found" />;
  return (
    <Summary
      branch={order.orderType === OrderType.pickup ? order?.branch : undefined}
      items={order.cartSnapshot.items || []}
      totals={
        order.totals
          ? {
              ...order.totals,
              orderType: order.orderType,
              discountBreakdown: order.discountBreakdown,
              ...taxFromTotals(order.totals),
            }
          : undefined
      }
    >
      {!!details.length && (
        <>
          <Divider className="m-30-v" />
          {details.map((row, index) => (
            <div key={row.label} className={index ? "m-20-t" : undefined}>
              <Text weight={"bold"} children={row.label} />
              <Text
                type="secondary"
                className="m-7-t"
                weight={"bold"}
                children={row.value}
              />
            </div>
          ))}
        </>
      )}
    </Summary>
  );
};

export default OrderSummary;
